import React from 'react';
import { Col, Row } from '../../../../../components/base/BootstrapComponents/BootstrapComponents';
import Switches from '../../../../../components/fields/Switches/Switches';
import { PROCEDURE_TYPE } from '../../../../../configs';
import { dateFormatter, infoFormatterIntl } from '../../../../../utils/formatters';
import FileView from '../../../../../components/fields/FileInput/FileView';

export default function ContractView(props) {
  const {
    fieldsValidation = {},
    procedure,
    currentApplication = {},
  } = props;

  const application_vehicle_new = currentApplication?.application_vehicle_new || {};
  const files = currentApplication?.files || [];

  const {
    ownership_contract_number,
    ownership_contract_effective_date,
    ownership_contract_expiration_date,
  } = application_vehicle_new;

  const registry_subject = currentApplication?.registry_subject || {};

  const {
    ownership_contract_number: oldOwnershipContractNumber,
    ownership_contract_effective_date: oldOwnershipContractEffectiveDate,
  } = registry_subject;

  const ownership_contract_files = files.filter(item => item.collection_name === 'ownership_contract_files');

  const hasContractData = !!(
    ownership_contract_number
      || ownership_contract_effective_date
      || ownership_contract_expiration_date
  ) || ownership_contract_number === null
    || ownership_contract_effective_date === null
    || ownership_contract_expiration_date === null;

  if (![PROCEDURE_TYPE.PROCEDURE_1227_8].includes(procedure)) {
    return null;
  }

  return (
    <>
      <Row className="row-cols-1">
        <Col>
          <Switches
            type="text"
            variant="material"
            inputProps={{
              onChange: () => {},
              value: hasContractData,
            }}
            label="Изменился договор"
          />
        </Col>
      </Row>
      {hasContractData && (
        <>
          <Row className="row-cols-2">
            {infoFormatterIntl(
              'old.number_and_date',
              !oldOwnershipContractNumber && !oldOwnershipContractEffectiveDate ? null : `${oldOwnershipContractNumber || ''} ${oldOwnershipContractEffectiveDate || ''}`,
              fieldsValidation,
              'ownership_contract_number',
            )}
          </Row>
          <Row className="row-cols-2">
            {infoFormatterIntl(
              'new.ownership_contract_number',
              ownership_contract_number,
              fieldsValidation,
              'application_vehicle_new.ownership_contract_number',
            )}
            {infoFormatterIntl(
              'new.ownership_contract_effective_date',
              dateFormatter(ownership_contract_effective_date),
              fieldsValidation,
              'application_vehicle_new.ownership_contract_effective_date',
            )}
          </Row>
          <Row className="row-cols-2">
            {infoFormatterIntl(
              'new.ownership_contract_expiration_date',
              dateFormatter(ownership_contract_expiration_date),
              fieldsValidation,
              'application_vehicle_new.ownership_contract_expiration_date',
            )}
          </Row>
          <Row className="row-cols-1">
            {infoFormatterIntl(
              'media.ownership_contract_files',
              ownership_contract_files.length ? (
                <FileView
                  readOnly
                  withoutMime
                  withoutHr
                  files={ownership_contract_files}
                />
              ) : null,
              fieldsValidation,
              '',
              6,
            )}
          </Row>
        </>
      )}
      <div className="hr-row mt-3" />
    </>
  );
}
